import React from "react";
import Nav from "./Nav";
import Hero from "./Hero";
import About from "./About";
import Services from "./Services";
import AuditTeaser from "./AuditTeaser";
import Certifications from "./Certifications";
import Tools from "./Tools";
import Blog from "./Blog";
import PlaybookTeaser from "./PlaybookTeaser";
import Contact from "./Contact";
import Footer from "./Footer";
import { Toaster } from "sonner";

export default function Site() {
  return (
    <div className="min-h-screen bg-paper text-ink selection:bg-ink selection:text-paper">
      <Nav />
      <main>
        <Hero />
        <About />
        <Services />
        <AuditTeaser />
        <Certifications />
        <Tools />
        <Blog />
        <PlaybookTeaser />
        <Contact />
      </main>
      <Footer />
      <Toaster
        position="bottom-right"
        offset={104}
        toastOptions={{
          style: {
            background: "#0A0A0A",
            color: "#FDFDFD",
            border: "1px solid #2A2A2A",
            borderRadius: 0,
            fontFamily: "Satoshi, sans-serif",
          },
        }}
      />
    </div>
  );
}
